<template>
  <v-snackbar v-model="showAlert" :timeout="timeout" :color="variant" top right>
    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="snackbar = false" icon>
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("alert", ["showAlert", "variant", "timeout", "message"]),
  },
};
</script>